const footer = {
  columns: [
    {
      title: "Company",
      links: [
        { name: "Contact", href: "mailto:support@wan22.io" },
        // { name: "Features", href: "#" },
        // { name: "Works", href: "#" },
        // { name: "Career", href: "#" },
      ]
    },  
  ],
  socialLinks: [
    { name: 'Twitter', href: 'https://x.com/aiveo3ai', icon: 'twitter' },
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/profile.php?id=61576369584191',
      icon: 'facebook',
    },
    { name: 'Instagram', href: 'https://www.instagram.com/anyvideo.ai/', icon: 'instagram' },
    { name: 'GitHub', href: '#', icon: 'github' },
  ],
  bottomLinks: [
    { name: "Privacy Policy", href: "/privacy" },
    { name: "Terms of Service", href: "/terms" },
    { name: "Refund Policy", href: "/refund-policy" },
  ]
};

export default footer;
